/* eslint-disable no-throw-literal */
import ApiService from 'app/services/ApiService';

export const COMMUNICATION_QUIZ_BEGIN = ' COMMUNICATION_QUIZ_BEGIN';
export const COMMUNICATION_QUIZ_SUCCESS = 'COMMUNICATION_QUIZ_SUCCESS';
export const COMMUNICATION_QUIZ_FAILURE = ' COMMUNICATION_QUIZ_FAILURE';
export const COMMUNICATION_QUIZ_CLEAR = ' COMMUNICATION_QUIZ_CLEAR';

export const RESPONSABLE_QUIZ_BEGIN = ' RESPONSABLE_QUIZ_BEGIN';
export const RESPONSABLE_QUIZ_SUCCESS = 'RESPONSABLE_QUIZ_SUCCESS';
export const RESPONSABLE_QUIZ_FAILURE = ' RESPONSABLE_QUIZ_FAILURE';
export const RESPONSABLE_QUIZ_CLEAR = ' RESPONSABLE_QUIZ_CLEAR';

export function fetchCommunicationQuiz(data) {
	return async dispatch => {
        dispatch(communicationQuizBegin());
        await ApiService.getCommunicationQuiz(data)
			.then(
				result => {
                    dispatch(communicationQuizSuccess(result));
				},
				error => {
                    dispatch(communicationQuizError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}

export function fetchResponsableQuiz(data) {
	return async dispatch => {
		dispatch(responsableQuizBegin());
        await ApiService.getResponsableQuiz(data)
		.then(
			result => {
                    dispatch(responsableQuizSuccess(result));
				},
				error => {
                    dispatch(responsableQuizError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}

//COMMUNICATION QUIZ
export const communicationQuizBegin = () => ({
    type:  COMMUNICATION_QUIZ_BEGIN,
});
export const communicationQuizSuccess = data => ({
    type: COMMUNICATION_QUIZ_SUCCESS,
	payload: { data }
})
export const communicationQuizError = () => ({
    type:  COMMUNICATION_QUIZ_FAILURE,
})
export const communicationQuizClear = () =>({
    type:  COMMUNICATION_QUIZ_CLEAR,
})

//RESPONSABLE QUIZ
export const responsableQuizBegin = () => ({
    type:  RESPONSABLE_QUIZ_BEGIN,
});
export const responsableQuizSuccess = data => ({
    type: RESPONSABLE_QUIZ_SUCCESS,
	payload: { data }
})
export const responsableQuizError = () => ({
    type:  RESPONSABLE_QUIZ_FAILURE,
})
export const responsableQuizClear = () =>({
    type: RESPONSABLE_QUIZ_CLEAR,
})

